export default `
    mutation MutResetPassword($email: String!,$resetPasswordToken:String!,$newPassword:String!) {
      resetPassword(
          email: $email
          resetPasswordToken: $resetPasswordToken
          newPassword: $newPassword
        )
}
`;
